<template>
  <div class="contract-input-item">
    <div class="contract-title">{{ info.title }}</div>
    <input
      v-if="!isStartGenerate"
      type="text"
      v-model="info.content"
      placeholder="请输入"
      maxlength="50"
    />

    <div v-else class="text">
      {{ info.content || "&nbsp;" }}
    </div>
  </div>
</template>

<script>
import message from "@/utils/message";
export default {
  name: "ContractInput",

  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    isStartGenerate: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isStartGenerate() {
      // if(this.isStartGenerate) {
      //   this.$nextTick(() => {
      //     const imgEl = document.querySelector('.contract-index-box img')
      //     imgEl.setAttribute('crossOrigin', 'Anonymous')
      //   })
      // } else {
      //   this.$nextTick(() => {
      //     const imgEl = document.querySelector('.contract-index-box img')
      //     imgEl.removeAttribute('crossOrigin')
      //   })
      // }
    },
  },
  mounted() {},
  methods: {
    getSubmitData() {
      const { title, isRequire, content, subjectType } = this.info;
      if (!isRequire) {
        return {
          questionnaire: 1,
          options: content,
          isRequired: isRequire ? 1 : 0,
          content: title,
          type: subjectType,
        };
      }
      if (!content) {
        message(`${title}未填写`);
        return false;
      }
      return {
        questionnaire: 1,
        options: content,
        isRequired: isRequire ? 1 : 0,
        content: title,
        type: subjectType,
      };
    },
  },
};
</script>

<style lang="stylus" scoped>
.contract-input-item {
  margin-top: 30px;
}

.contract-title {
  font-size: 16px
  font-weight: bold
}

input {
  margin: 10px 0 0;
  width: 100%;
  height: 30px !important
  font-size: 14px;
  font-weight: 400;
}
.text{
  font-size: 14px;
  font-weight: 400;
  word-break: break-all;
}
</style>
